const list = {
  data () {
    return {
      first: true,
      dialog: {
        view: false,
        save: false,
        selected: this.default
      }
    }
  },

  watch: {
    get_data: {
      deep: true,
      handler () {
        if (this.first) this.initialize()
        this.first = false
      }
    },
    routerPath: {
      deep: true,
      handler () {
        this.initialize()
      }
    }
  },

  methods: {
    initialize () {
      if (this.routerPath && parseInt(this.routerPath.id) > 0) {
        const data = (this.items ? this.items : this.get_data[this.routerPath.root])
        const item = data.find(element => element.id === parseInt(this.routerPath.id))
        if (item) {
          switch (this.routerPath.action) {
            case 'view':
              this.viewDialog(item)
              break
            case 'edit':
              this.editDialog(item)
              break
          }
        } else {
          this.$store.dispatch('snackBar', { type: 1, message: this.lang[this.routerPath.root].messages.error.not_found })
        }
      } else if (this.routerPath && this.routerPath.action === 'new') {
        this.newDialog()
      } else {
        this.resetDialog()
      }
    },
    newDialog () {
      // this.dialog.selected = Object.assign({}, { ...this.default })
      this.dialog.selected = JSON.parse(JSON.stringify({ ...this.default }))
      this.dialog.view = false
      this.$router.push({ name: this.routerPath.root + ':new' }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.save = true
    },
    viewDialog (item) {
      this.dialog.selected = item
      this.dialog.save = false
      this.$router.push({
        name: this.routerPath.root + ':view',
        params: {
          id: item.id
        }
      }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.view = true
    },
    editDialog (item) {
      const item_ = Object.entries(item)
      const item__ = {}
      item_.forEach((value_, key_) => {
        key_ = value_[0]
        value_ = value_[1]
        if (value_ && value_.constructor.name === 'Array') {
          const blank_ = []
          item__[key_] = blank_.concat(value_)
        } else if (value_ && value_.constructor.name === 'Object') {
          item__[key_] = { ...value_ }
        } else {
          item__[key_] = value_
        }
      })
      this.dialog.selected = Object.assign({}, item__)
      this.dialog.view = false
      this.$nextTick(function () {
        this.$router.push({
          name: this.routerPath.root + ':edit',
          params: {
            id: item.id
          }
        }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
        this.dialog.save = true
      }.bind(this))
    },
    resetDialog () {
      this.dialog.selected = this.default
      this.dialog.view = false
      this.dialog.save = false
    },
    onCloseView (val) {
      if (val) this.$router.push({ name: this.routerPath.root }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.view = !val
    },
    onCloseSave (val) {
      if (val) this.$router.push({ name: this.routerPath.root }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.save = !val
    }
  },

  created () {
    this._onPopState = () => {
      console.log('popstate!')
      this.initialize()
    }
    window.addEventListener('popstate', this._onPopState)
    this.initialize()
  },

  destroyed () {
    window.removeEventListener('popstate', this._onPopState)
    this._onPopState = null
  }
}

export default list
